import { createFileRoute } from '@tanstack/react-router';
import TransactionsAudit from 'src/pages/Organization/Event/TransactionsAudit';

export const Route = createFileRoute(
  '/$organizationSlug/events/$eventId/transactions_audit',
)({
  component: () => <TransactionsAudit />,
});
